@if (hasPermission) {
    <div
        class="sidenav"
        [ngClass]="{'collapsed': !mwNavComponent?.isNavExpanded}"
    >
        <app-mw-left-nav
            #leftNavComponent
            [currentWidgetId]="currentWidgetId"
            [namedQuery]="namedQuery"
            [entitlements]="entitlements"
            [clientCode]="clientCode ?? ''"
            (transitionEnd)="onTransitionEnd()"
            (namedQueryChanged)="onUpdateNamedQuery($event)"
            (autoAddDynamicColumnsChanged)="onUpdateAutoAddDynamicColumnsVisualizations($event)"
        >
        </app-mw-left-nav>
    </div>
}

<div
    class="layout-wrapper"
    id="layout-wrapper"
    [ngClass]="{'expanded': mwNavComponent?.isNavExpanded, 'collapsed': !mwNavComponent?.isNavExpanded}"
>
    @if (hasPermission) {
        <app-mw-dashboard
            #dashboardComponent
            [navRef]="mwNavComponent"
            [namedQuery]="namedQuery"
            [autoAddDynamicColumnsVisualizations]="autoAddDynamicColumnsVisualizations"
            [clientCode]="clientCode"
            [clients]="clients ?? []"
            [entitlements]="entitlements"
            [user]="user"
            [ccFuzzyDates]="fuzzyDates ?? []"
            [funds]="funds"
            [userPreferences]="preferences"
            (revertChanges)="onRevertChanges($event)"
        >
        </app-mw-dashboard>
    }

    <div #dummyDashboardDiv id="dashboardDummyDiv" class="dummy-dashboard-margin">
        <div class="margin-container"></div>
    </div>

    <div id="mw_ws" class="dashboard-container" #dashboardContainer>
        <div class="margin-container">
            <canvas id="grid-canvas" #gridcanvas></canvas>
            @if (initializationErrors.length) {
                <ddv-initialization-errors [errors]="initializationErrors"></ddv-initialization-errors>
            } @else {
                <app-dashboard [isManagingWidget]="true"></app-dashboard>
            }
        </div>
    </div>

    <app-socket data-html2canvas-ignore="true"></app-socket>
</div>
